// extracted by mini-css-extract-plugin
module.exports = {"navbar":"style__navbar__Y9bI0","logo":"style__logo__PgcIE"};